import { DestinationDetails } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class DestinationsResponseModel extends GlobalResponseObject {
    data?: DestinationDetails[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /ProductDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: DestinationDetails[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

